"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.banksFrom = void 0;
const institutions_json_1 = __importDefault(require("./institutions.json"));
class BankRepository {
    constructor(banks) {
        this.banks = banks;
    }
    list() {
        return Object.values(this.banks).sort((a, b) => parseInt(a.code, 10) - parseInt(b.code, 10));
    }
    nameByCode(code) {
        var _a;
        return (_a = this.banks[code]) === null || _a === void 0 ? void 0 : _a.name;
    }
}
const banksFrom = (country) => {
    const countryHashTable = institutions_json_1.default;
    return new BankRepository(countryHashTable[country].banks);
};
exports.banksFrom = banksFrom;
